module.exports = __webpack_public_path__ + "static/media/logoWhite.723db622.png";